var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(_vm.imgStyle),attrs:{"src":_vm.img.src || ("https://via.placeholder.com/" + (_vm.img.width || 200) + "x" + (_vm.img.height || 150) + "?text=IMAGE"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }